import { supabase } from '@/lib/integrations/supabase'
import { getMovementTypeByKey } from './movementTypesService'
import type { CreateMovementInput, CreateMovementItemInput } from './movementsTypes'

export async function createMovement(input: CreateMovementInput) {
  const movementType = await getMovementTypeByKey(
    input.contextKey,
    input.movementTypeKey,
  )

  const { data, error } = await supabase
    .from('movements')
    .insert({
      unit_id: input.unitId,
      party_id: input.partyId ?? null,
      movement_type_id: movementType.id,
      movement_date: input.movementDate ?? new Date().toISOString().slice(0, 10),
      description: input.description ?? null,
      status: input.status ?? 'confirmed',
      notes: input.notes ?? null,
      attrs: input.attrs ?? {},
    })
    .select('*')
    .single()

  if (error) throw error
  return data
}

export async function createMovementItem(input: CreateMovementItemInput) {
  const { data, error } = await supabase
    .from('movement_items')
    .insert({
      movement_id: input.movementId,
      asset_id: input.assetId ?? null,
      line_number: input.lineNumber ?? null,
      external_code: input.externalCode ?? null,
      description: input.description ?? null,
      source_holding_id: input.sourceHoldingId ?? null,
      target_holding_id: input.targetHoldingId ?? null,
      quantity: input.quantity,
      uom: input.uom,
      unit_cost: input.unitCost ?? null,
      total_cost: input.totalCost ?? null,
      attrs: input.attrs ?? {},
    })
    .select('*')
    .single()

  if (error) throw error
  return data
}

export async function createMovementWithItems(
  movementInput: CreateMovementInput,
  items: Omit<CreateMovementItemInput, 'movementId'>[]
) {
  const movement = await createMovement(movementInput)

  const movementItems = await Promise.all(
    items.map((item) =>
      createMovementItem({
        ...item,
        movementId: movement.id,
      })
    )
  )

  return {
    movement,
    items: movementItems,
  }
}
